import Table from '@components/table'
import Image from '@components/image'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { Category } from '@apis'
import Typography from '@components/typography'
import TableActions from '@components/table/actions'
import { useNavigate } from 'react-router-dom'
import Alert from '@commons/popups/alert'
const DepartmentList = () => {
  const navigate = useNavigate()
  const [deleteInfo, setDeleteInfo] = useState({
    visible: false,
    id: null,
    loading: false,
  })
  const { data: categories } = useSelector(
    (state: any) => state.specializations,
  )
  const columns = [
    {
      key: 'image',
      title: 'Department Icon',
      render: (item) => {
        return (
          <Image
            width={50}
            height={50}
            src={`${process.env.BUCKET_URL}/${item?.infos?.image}`}
            styleImage={`border-radius:50%;`}
          />
        )
      },
    },
    {
      key: 'parentName',
      title: 'Department',
    },
    {
      key: 'name',
      title: 'Specialization',
    },
    {
      key: 'symptoms',
      title: 'Symptoms',
      render: (item) => {
        return <Typography content={`${item?.symptoms?.length}+ Symptoms`} />
      },
    },
    {
      key: 'actions',
      title: 'Actions',
      render: (item) => {
        return (
          <TableActions
            hasView={false}
            onClickEdit={() => {
              navigate('/admin/category-management?tab=department', {
                state: item,
              })
            }}
            onClickDelete={() => {
              setDeleteInfo({
                visible: true,
                id: item?.id,
                loading: false,
              })
            }}
          />
        )
      },
    },
  ]
  const fetchData = async () => {
    await Category.list({
      state: 'specializations',
      params: {
        type: 'Specialization',
      },
    }).catch(() => {})
  }
  const removeData = async () => {
    setDeleteInfo({
      ...deleteInfo,
      loading: true,
    })
    await Category.remove({
      id: deleteInfo?.id,
      state: 'specializations',
    })
      .then(() => {
        navigate('/admin/category-management?tab=department')
      })
      .catch(() => {})
    setDeleteInfo({
      ...deleteInfo,
      visible: false,
      loading: false,
    })
  }
  useEffect(() => {
    if (!categories?.length) {
      fetchData()
    }
  }, [])

  return (
    <>
      <Table
        filter={{
          hasSearch: true,
          searchFrom: 'name',
        }}
        data={categories}
        columns={columns}
      />
      <Alert
        visible={deleteInfo?.visible}
        loading={deleteInfo?.loading}
        onClickOk={removeData}
        onClickClose={() => {
          setDeleteInfo({
            visible: false,
            id: null,
            loading: false,
          })
        }}
      />
    </>
  )
}

export default DepartmentList
